export default "__VITE_ASSET__Bqih7nxq__"